import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { GlobalService } from '@commoncore/services/global.service';

@Injectable({
  providedIn: 'root'
})
class SemanticSearchGuard {
  public localStorageSvc:any;
  public universalService:any;
  public router:any;
  constructor(public globalService:GlobalService){
      this.setEnvObjects(globalService);
  }

  setEnvObjects(globalService){
    this.localStorageSvc = globalService.getLocalStorageSvcRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.router = globalService.getRouterRef()
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> | boolean {
    var userData = this.localStorageSvc.getUserData(true);
    let activate = userData["simSearchTwoAi"][route.data.check];
    if(!this.universalService.inAppWebViewOpened && activate != "A"){
      this.router.navigate(['/home']);
      return Promise.resolve(false);
    }else{
      return Promise.resolve(true);
    }
  }
}

export const EnableSemanticSearch: CanActivateFn =
    (route, state) => {
      return inject(SemanticSearchGuard).canActivate(route,state);
    }
